import React, { useState } from 'react';
import './MultiPositionSwitch.scss';

interface MultiPositionSwitchProps {
    label: string;
    value: string;
    options: string[];
    onChange: (selectedOption: string) => void;
}

export const MultiPositionSwitch: React.FC<MultiPositionSwitchProps> = ({ label, value, options, onChange }) => {

    const handleOptionClick = (option: string) => {
        onChange(option);
    };

    return (
        <div className='multi-position-switch-container'>
            <div>{label}</div>
            <div className="multi-position-switch">
                {options.map((option, index) => (
                    <div
                        key={index}
                        className={`switch-option ${value === option ? 'active' : ''}`}
                        onClick={() => handleOptionClick(option)}
                    >
                        {option}
                    </div>
                ))}
            </div>
        </div>

    );
};

